/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { getVintageAvailableYears, showNotification } from 'src/core/helpers'
import { CreateBrokerageProjectPayload, ProjectKindType } from 'src/core/models'
import { createBrokerageProjectSelector, createProject, resetProjectCreateState } from 'src/features'
import {
  CustomModal, CustomTextInput, CustomSelect, CustomInputNumber,
  CustomInputDecimal, CustomImageInput, CustomText, CustomCheckBox
} from 'src/components'
const { Option } = Select

interface ProjectRegisterModalProps {
  isModalVisible: boolean
  // eslint-disable-next-line no-unused-vars
  setIsModalVisible: (value: boolean) => void
  email: string
}

const ProjectRegisterModal: React.FC<ProjectRegisterModalProps> = (props) => {
  const { isModalVisible, setIsModalVisible, email } = props
  const [isVintage, setIsVintage] = useState(false)
  const [selectedKind, setSelectedKind] = useState<ProjectKindType>(null)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [form] = Form.useForm()
  const years = getVintageAvailableYears([], selectedKind)

  const { loading, success } = useAppSelector((createBrokerageProjectSelector))

  const onFinish = async (values: CreateBrokerageProjectPayload) => {
    if (!email) {
      setIsModalVisible(false)
      dispatch(resetProjectCreateState())
      showNotification('error', t('admin.Brokerage.EmailRequired'))
      return
    }
    const params = { ...values, email }
    dispatch(createProject(params, isVintage))
  }

  useEffect(() => {
    if (success) {
      setIsModalVisible(false)
      showNotification('success', t('admin.Brokerage.ProejctCreateSuccess'))
      dispatch(resetProjectCreateState())
    }
  }, [success])

  const stockLabel = {
    compensation: t('admin.Brokerage.TotalCo2'),
    contribution: t('admin.Brokerage.TotalContribution'),
    energy: t('admin.Brokerage.totalMwh')
  }[selectedKind] || t('admin.Brokerage.InitialStock')

  const getTitle = () => {
    const emailAux = !email ? t('admin.Brokerage.NonEmail') : email
    return `${t(`admin.Brokerage.CreateProject`)}: ${emailAux}`
  }

  const handleClose = () => {
    setIsVintage(false)
    form.resetFields()
    setIsModalVisible(false)
  }

  return <>
    <CustomModal
      title={getTitle()}
      footer={null}
      open={isModalVisible}
      maskClosable={false}
      onCancel={() => handleClose()}
    >
      <Form
        name='personalDataForm'
        onFinish={onFinish}
        autoComplete='off'
        form={form}
      >
        {/* Project Name */}
        <CustomText label={t('admin.Brokerage.ProjectName')} />
        <CustomTextInput
          name='name'
          required
          placeholder={t('admin.Brokerage.ProjectNamePlaceHolder')}
        />

        {/* Project Kind */}
        <CustomText label={t('admin.Brokerage.ProjectKind')} />
        <CustomSelect
          required
          name='kind'
          placeholder={t('admin.Brokerage.SelectPlaceHolder')}
          onChange={(value: ProjectKindType) => {
            setIsVintage(false)
            setSelectedKind(value)
          }}
        >
          <Option key={'compensation'}>{t('admin.Brokerage.Compensation')}</Option>
          <Option key={'energy'}>{t('admin.Brokerage.Energy')}</Option>
          <Option key={'contribution'}>{t('admin.Brokerage.NBS')}</Option>
        </CustomSelect>

        {/* Vintage Check Box */}
        {(selectedKind && selectedKind !== 'contribution') && <>
          <CustomCheckBox
            defaultValue={isVintage}
            handleChange={(value) => setIsVintage(value)}
            text={t('Projects.VintagePlaceholder')}
            className={'mb-5'}
            isSmallText
          /><br />
        </>}

        {/* Vintage Year */}
        {isVintage && <>
          <CustomText label={t('admin.Brokerage.YearRequest')} />
          <CustomSelect
            required
            name={'vintageYear'}
            placeholder={t('Projects.YearPlaceholder')}
          >{years.map(year => <Option key={year}>{year}</Option>)}
          </CustomSelect>
        </>}

        {/* Stock */}
        <CustomText label={stockLabel} />
        <CustomInputNumber
          name='volume_credits'
          placeholder={t('admin.Brokerage.StockPlaceHolder')}
          required
        />

        {/* Stock */}
        <CustomText label={t('admin.Brokerage.Price')} />
        <CustomInputDecimal
          name='price'
          placeholder={t('admin.Brokerage.PricePlaceHolder')}
          required
        />

        {/* Cover */}
        <CustomText label={t('Projects.Form.MainImage')} />
        <CustomImageInput
          name='main_image'
          imagePreviewWidth={190}
          mobilePreviewWidth={300}
          required
        />

        {/* Footer Description */}
        <div className='mb-5 mt-5'>
          <CustomText label={t('admin.Brokerage.ProjectFormText')} type='secondary' /> <br />
          {isVintage && <CustomText label={t('admin.Brokerage.SingleVintage')} type='secondary' />}
        </div>

        {/* Buttons */}
        <Button
          type='primary'
          htmlType='submit'
          size='large'
          className='radius-100'
          block
          loading={loading}
        >
          {loading ? <>{t('admin.Brokerage.CreatingProject')}</> : <>{t('general.Submit')}</>}
        </Button>
      </Form>
    </CustomModal>
  </>
}
export default ProjectRegisterModal
